module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAVCAYAAADM+lfpAAAAAXNSR0IArs4c6QAAAD9JREFUSA1j/A8EDIMEMA0Sd4CdMagcM5gCZtQtoyEwtEOAcbTQwxGBo4UejoAZFR4NgaEdAqOFHq74G1SFHgBMOgwEDi5tCQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/more-logo.png
// module id = 1135
// module chunks = 0